export default __webpack_public_path__ + "static/media/jrz-conectado.c0d70c26.png";